module.exports = __webpack_public_path__ + "static/media/iPhone.558de53e.jpg";